import { useState } from 'react';

// Étoiles 1-5. Mode interactif (onChange) ou lecture seule (readOnly, accepte une moyenne décimale).
function StarRating({ value = 0, onChange, size = 'md', readOnly = false }) {
  const [hover, setHover] = useState(0);
  const stars = [1, 2, 3, 4, 5];

  if (readOnly) {
    const rounded = Math.round(value);
    return (
      <span className={`stars stars--${size} stars--ro`} aria-label={`${value}/5`}>
        {stars.map((s) => (
          <span key={s} className={`star ${s <= rounded ? 'is-on' : ''}`}>★</span>
        ))}
      </span>
    );
  }

  const active = hover || value;
  return (
    <div className={`stars stars--${size}`} onMouseLeave={() => setHover(0)} role="radiogroup">
      {stars.map((s) => (
        <button
          key={s}
          type="button"
          className={`star ${s <= active ? 'is-on' : ''}`}
          onMouseEnter={() => setHover(s)}
          onClick={() => onChange && onChange(s)}
          aria-label={`${s} / 5`}
        >
          ★
        </button>
      ))}
    </div>
  );
}

export default StarRating;
